import imageDe from '../images/de/uploader-abbottLite-problem-2.png';
import imageEn from '../images/en/uploader-abbottLite-problem-2.png';
import imageEs from '../images/es/uploader-abbottLite-problem-2.png';
import imageFi from '../images/fi/uploader-abbottLite-problem-2.png';
import imageFr from '../images/fr/uploader-abbottLite-problem-2.png';
import imageIt from '../images/it/uploader-abbottLite-problem-2.png';
import imageNo from '../images/no/uploader-abbottLite-problem-2.png';
import imageSv from '../images/sv/uploader-abbottLite-problem-2.png';

export const uploaderTryAgainImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
